<template>
<div class="card" style="background:transparent;">
    <div class="card-header" :id="'heading' + location.id + '_' + documentIndex">
      <h5 class="mb-0">
        <button @click="toggleExpanded" class="btn btn-link collapsed" data-toggle="collapse" :data-target="'#collapse' + location.id + '_' + documentIndex" :aria-expanded="isExpanded" :aria-controls="'collapse' + location.id + '_' + documentIndex">
          <span class="date-of-origin">{{ document.date_of_origin|truncate(40) }}<br></span>
          {{ location.display_name }}<br>
          <img :src="'/img/dot-' + document['type'] + '.svg'" :alt="translate('label.charter.' + document['type'])"> <img v-if="document['currently_on_display'] == 1" src="/img/dot-on-display.svg" :alt="translate('label.charter.currently_on_display')"> {{ document.shelfmark }}
          <div class="acc_toggle"></div>
        </button>
      </h5>
    </div>

    <div :id="'collapse' + location.id + '_' + documentIndex" class="collapse" :aria-labelledby="'heading' + location.id + '_' + documentIndex" data-parent="#accordion">
      <div class="card-body side">
        <image-view v-if="document.image_name_recto && isExpanded"
          :image-server-base-path="document.image_server_base_path"
          :filename="document.image_name_recto"
          :width="200"
          :link="'/charters/view/' + document.id"
          :responsive="true">
        </image-view>

        <div v-if="!document.image_name_recto" class="placeholder-image-container">
          <img class="img-fluid" src="https://dummyimage.com/300x150/000/fff.jpg&text=No+image+available" alt="Placeholder">
        </div>
    
        <template v-if="document.regests">
          <h4>{{ translate('label.charter.regest') }}</h4>
          <p>
            <truncate-text 
              :text="document.regest ? document.regest : ''"
              :max-chars="200"
              :parse-link="true"
              :show-more-text="translate('label.more')"
              :show-less-text="translate('label.less')">
            </truncate-text>
          </p>
        </template>

        <h4>{{ translate('label.location.location_type') }}</h4>
        <p><location-type-display :document-location-types="document['pivot']['location_types']"></location-type-display></p>

        <h4>{{ translate('label.charter.type') }}</h4>
        <p>{{ translate('label.charter.' + document.type) }}</p>
        
        <h4>{{ translate('label.charter.place_of_origin') }}</h4>
        <p>{{ document.place_of_origin || translate('label.no_info') }}</p>

        <h4>{{ translate('label.charter.date_of_origin') }}</h4>
        <p>{{ document.date_of_origin }}</p>

        <h4>{{ translate('label.charter.material') }}</h4>
        <p>{{ translate('label.charter.' + document.material) }}</p>

        <h4>{{ translate('label.charter.dimensions') }}</h4>
        <p>{{ document.dimensions }}</p>

        <h4>{{ translate('label.charter.transmission') }}</h4>
        <p>{{ translate('label.charter.' + document.transmission) }}</p>

        <h4>{{ translate('label.charter.language') }}</h4>
        <p>{{ translate('label.charter.' + document.language) }}</p>

        <h4>{{ translate('label.charter.chla') }}</h4>
        <p>{{ document.chla_reference }}</p>

        <h4>{{ translate('label.charter.cs') }}</h4>
        <p>{{ document.cs_number }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    location: { type: Object, required: true},
    document: { type: Object, required: true},
    locationIndex: { type: Number, required: true},
    documentIndex: { type: Number, required: true},
  },

  data() {
    return {
      isExpanded: false
    }
  },

  methods: {
    toggleExpanded() {
      this.isExpanded = !this.isExpanded;
    }
  }
}
</script>

<style lang="scss" scoped>
  .placeholder-image-container {
    margin: auto auto;
    max-width: 100%;
    max-height: 10rem !important;
    width: auto !important;
    height: auto !important;
    background: #000;
    text-align: center;
    margin-bottom: 1rem;
  }
  .mb-0 img {
    vertical-align: baseline;
    margin-right: .125rem;
  }
</style>


